import { Box, Button, Typography } from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { Link } from "react-router-dom";
import { gameDefinitions } from "../games/gameDefinitons";

const featuredGame = gameDefinitions.find(
  (game) => game.name === "risky-space"
)!;

export function HeroSection() {
  return (
    <Box
      component="section"
      aria-labelledby="home-title"
      className="site-motion"
      sx={{
        maxWidth: 1200,
        mx: "auto",
        px: { xs: 2, sm: 3 },
        py: { xs: 5, md: 9 },
        display: "grid",
        gridTemplateColumns: {
          xs: "minmax(0, 1fr)",
          md: "minmax(0, 1.15fr) minmax(0, 1fr)"
        },
        alignItems: "center",
        gap: { xs: 4, md: 7 }
      }}
    >
      <Box sx={{ minWidth: 0 }}>
        <Typography
          sx={{
            fontFamily: "'JetBrains Mono', monospace",
            color: "text.secondary",
            fontSize: "0.8125rem",
            mb: 2
          }}
        >
          Made by Scott Brown
        </Typography>
        <Typography
          id="home-title"
          component="h1"
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "0.2em",
            fontSize: "clamp(2.5rem, 5vw, 4.5rem)",
            fontWeight: 700,
            lineHeight: 1.1,
            letterSpacing: "-0.05em",
            mb: 3
          }}
        >
          <Box
            component="img"
            src="/apple-touch-icon.png"
            alt=""
            width={72}
            height={72}
            sx={{ width: "1em", height: "1em", flexShrink: 0 }}
          />
          <Box
            component="span"
            sx={(theme) => ({
              background: theme.palette.heroGradient,
              backgroundClip: "text",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent"
            })}
          >
            ScottDB.Net
          </Box>
        </Typography>
        <Typography
          sx={{
            fontSize: { xs: "1.0625rem", sm: "1.25rem" },
            lineHeight: 1.7,
            maxWidth: "38ch",
            color: "text.secondary"
          }}
        >
          Games, useful tools, and interactive experiments. Pick something to
          play, make, or explore.
        </Typography>
        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1.5, mt: 3.5 }}>
          <Button
            component={Link}
            to="/games"
            variant="contained"
            endIcon={<ArrowForwardIcon />}
          >
            Explore games
          </Button>
          <Button component={Link} to="/tools" variant="outlined">
            Find a tool
          </Button>
        </Box>
        <Typography variant="body2" sx={{ mt: 3, color: "text.secondary" }}>
          Built for curiosity. Open in your browser.
        </Typography>
      </Box>
      <Box
        component="article"
        aria-labelledby="featured-game-title"
        sx={{
          bgcolor: "background.paper",
          border: 1,
          borderColor: "divider",
          borderRadius: "12px",
          overflow: "hidden",
          minWidth: 0
        }}
      >
        <Box
          sx={{
            position: "relative",
            aspectRatio: "16 / 9",
            bgcolor: "#101018"
          }}
        >
          <Box
            component="img"
            src={featuredGame.image}
            alt="Purple and orange planets connected by fleet routes"
            fetchPriority="high"
            sx={{
              position: "absolute",
              inset: 12,
              width: "calc(100% - 24px)",
              height: "calc(100% - 24px)",
              objectFit: "contain"
            }}
          />
        </Box>
        <Box sx={{ p: { xs: 2.5, sm: 3 } }}>
          <Typography
            sx={{
              color: "primary.main",
              fontFamily: "'JetBrains Mono', monospace",
              fontSize: "0.75rem",
              mb: 1
            }}
          >
            Featured game
          </Typography>
          <Typography
            id="featured-game-title"
            component="h2"
            variant="h5"
            sx={{ mb: 1 }}
          >
            {featuredGame.title}
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            {featuredGame.summary}
          </Typography>
          <Button
            component={Link}
            to={`/games/${featuredGame.name}`}
            variant="outlined"
            endIcon={<ArrowForwardIcon />}
          >
            Play Risky Space
          </Button>
        </Box>
      </Box>
    </Box>
  );
}
